
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AlertModal from 'web/components/AlertModal';
import DebitCard from '../../Debit-Credit-Card';
import RightArrow from "web/assets/images/right-arrow-dark-blue.webp";
import { Tooltip } from 'reactstrap';
import information from "web/assets/images/informationIcon.png";
import * as moment from "moment";
import TextInput from 'web/components/form-elements/TextInput';
import { StepFiveContainer, CreditCardSection, SubHeading, PromoCodeSection } from "web/pages/account/registration/corporate-Registration-Styled";
import { promoCodeApi } from 'redux/actions/register'

export default ({ setFieldValue, props, pageLanguageContents }) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const defaultPromoCodeValue = process.env.REACT_APP_FREE_PROMOCODE
  const [subscriptionText, setSubscriptionText] = useState('')
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const [alertType, setAlertType] = useState('');
  const toggleModal = () => setModal(!modal);
  const [promoCodeValidate, setPromoCodeValidate] = useState(false);

  useEffect(() => {
    if (props.values?.appliedPromoCodeDetails?.promoCode) {
      let tempValue = props.values?.appliedPromoCodeDetails
      let promoName = tempValue?.promoCode
      let promoNumber = tempValue?.timeSpanForBenefits?.number
      let promoPeriod = tempValue?.timeSpanForBenefits?.timeDMY
      let nextBilling = tempValue?.chargedDate
      let nextBillingFormatted = moment(nextBilling).format('MM/DD/YYYY')
      let subsTextString = `Great News! Promo Code '${promoName}' applied for ${promoNumber} free ${promoPeriod?.toLowerCase()}s! Your card will not be charged until ${nextBillingFormatted}.`
      setSubscriptionText(subsTextString)
    }
  }, [props])

  useEffect(() => {
    localStorage.removeItem('promoCode')
    setSubscriptionText('')
    callDefaultPromoApplyFunction()
  }, [])

  const callDefaultPromoApplyFunction = async () => {
    const { setFieldValue, setTouched, isValid } = props;
    const isGuestUserUpgrade = localStorage.getItem('guestUserUpgrade');
    if (defaultPromoCodeValue && isGuestUserUpgrade) {
      const response = await dispatch(promoCodeApi(defaultPromoCodeValue));
      localStorage.setItem('promoCode', '');
      if (response.status === "SUCCESS") {
        setPromoCodeValidate(true)
        setFieldValue('promoCodeInput', defaultPromoCodeValue)
        setFieldValue('promoOrReferralValidated', true)
        setTouched({})

        if (response.payload.isPromoCode) {
          localStorage.setItem('promoCode', response.payload.promoCode);
          localStorage.setItem('referralCode', '');
          setFieldValue('appliedPromoCodeDetails', response.payload)
        }
      }
    }
  }

  const [tooltipMemberShip, setTooltipMemberShip] = useState(false);
  const iIconMemberShip = (infoTxt) => {
    return <>
      <img
        id="TooltipMemberShip"
        src={information}
        style={{
          paddingLeft: "5px",
          position: "relative",
          top: "-1px",
        }}
      />
      <Tooltip
        placement="right"
        isOpen={tooltipMemberShip}
        target="TooltipMemberShip"
        toggle={() =>
          setTooltipMemberShip(!tooltipMemberShip)
        }
      >
        {infoTxt}
      </Tooltip>
    </>
  }

  const [tooltipRefferal, setTooltipRefferal] = useState(false);
  const iIconRefferal = (infoTxt) => {
    return <>
      <img
        id="TooltipRefferal"
        src={information}
        style={{
          paddingLeft: "5px",
          position: "relative",
          top: "-1px",
        }}
      />
      <Tooltip
        placement="right"
        isOpen={tooltipRefferal}
        target="TooltipRefferal"
        toggle={() =>
          setTooltipRefferal(!tooltipRefferal)
        }
      >
        {infoTxt}
      </Tooltip>
    </>
  }

  const promoCodeApiFun = async () => {
    const { setFieldValue, setTouched, isValid } = props;

    if (!props.values.promoCodeInput.trim()) {
      setModalContent("Please enter promo or referral code first.");
      setModalLink('');
      toggleModal();
    } else {
      const response = await dispatch(promoCodeApi(props.values.promoCodeInput.trim()));
      localStorage.setItem('referralCode', '');
      localStorage.setItem('promoCode', '');
      if (response.status === "SUCCESS") {
        setPromoCodeValidate(true)
        setFieldValue('promoOrReferralValidated', true)
        setTouched({})

        if (response.payload.isPromoCode) {
          localStorage.setItem('promoCode', response.payload.promoCode);
          localStorage.setItem('referralCode', '');
          setFieldValue('referralCode', '')
          setFieldValue('appliedPromoCodeDetails', response.payload)

          setModalContent("Promo code applied successfully.");
          setModalLink('');
          toggleModal();
        }
        if (response.payload.isReferralCode) {
          localStorage.setItem('promoCode', '');
          localStorage.setItem('referralCode', response.payload.referralCode);
          let typeVal = ""
          if (response.payload.referralCodeConfig.ownerBenefitType === "DAY") {
            if (response.payload.referralCodeConfig && response.payload.referralCodeConfig.invitedBenefitDuration === 1) {
              typeVal = "day"
            } else {
              typeVal = "days"
            }
          } else if (response.payload.referralCodeConfig.ownerBenefitType === "MONTH") {
            if (response.payload.referralCodeConfig && response.payload.referralCodeConfig.invitedBenefitDuration === 1) {
              typeVal = "month"
            } else {
              typeVal = "months"
            }
          } else {
            if (response.payload.referralCodeConfig && response.payload.referralCodeConfig.invitedBenefitDuration === 1) {
              typeVal = "year"
            } else {
              typeVal = "years"
            }
          }

          setModalContent("Referral code applied successfully.");
          setModalLink('');
          toggleModal();
        }
      }
      else {
        if (response.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in')
          window.location.reload(false);
        } else {
          if (response.message === 'Invalid code') {
            setModalContent('This promo or referral code is invalid. Please try again.');
          } else {
            setModalContent(response.message);
          }
          setTouched({})
          setFieldValue('promoCode', null)

          setModalLink('');
          toggleModal();
        }
      }
    }
  }

  return (
    <>
      <CreditCardSection>
        <SubHeading>
          <img src={RightArrow} className="right-arrow" alt="right-arrow" />
          Promo Code
        </SubHeading>
        <div className="row mx-0">
          <div className=" col-xs-12 col-sm-6 select-height">
            <div>
              <div className="mb-2 label-color">
                <p>
                  Promo Code/Referral Code
                  {iIconRefferal('Have you been referred by a friend or have a promo code? Input it here and hit the Apply button.')}
                </p>
              </div>
              <div className='promocode-text-wrapper' style={{ display: 'flex', gap: "10px" }}>
                <TextInput disabled={promoCodeValidate ? true : false} name="promoCodeInput" />
                <PromoCodeSection>
                  <div
                    type="app-green-button"
                    disabled={promoCodeValidate ? true : false}
                    onClick={(e) => {
                      if (!promoCodeValidate) {
                        promoCodeApiFun();
                      }
                    }}
                  >
                    {promoCodeValidate ? "Applied" : "Apply"}
                  </div>
                </PromoCodeSection>
              </div>
            </div>

          </div>

          <div className=" col-xs-12 col-sm-6 select-height">
            <p style={{ fontWeight: 'bold' }}>Don’t have a promo code? Use <span style={{ color: '#61ae24' }}>{defaultPromoCodeValue}</span> for a free one year of subscription on us.</p>
          </div>
        </div>
      </CreditCardSection>

      <StepFiveContainer>
        <CreditCardSection>
          <SubHeading>
            <img src={RightArrow} className="right-arrow" alt="right-arrow" />
            {pageLanguageContents?.Arrow2_Account[74]?.Sub_Arrow}<span className="star">*</span>
            {iIconMemberShip(pageLanguageContents?.Arrow2_Account[105]?.Membership_Info)}
          </SubHeading>
          <div className='col-12'>
            {props.values?.reseller && <p style={{ margin: '0px', fontSize: '17px' }}>Please populate a valid payment method for the subscription fee of <span style={{ whiteSpace: 'nowrap' }}>{props.values?.reseller === "deActive" ? '$79 + tax ' : '$249 + tax '}</span>per month.</p>}
          </div>

          <div className='col-12'>
            {localStorage.getItem('promoCode') && subscriptionText && <p style={{ fontSize: '17px', fontWeight: 'bold', color: '#27911B' }}>{subscriptionText}</p>}
          </div>

          <div className="col-12" style={{ overflow: 'hidden' }}>
            {props.values?.membershipPaymentValidated && <div className="freezeDivCredit"></div>}
            <div>
              <div className="text-left mt-4 mb-2">
                <DebitCard
                  cardType="creditCard"
                  accountType="paymentSubscription"
                  stepSelected=""
                  props={props}
                  setFieldValue={setFieldValue}
                  id={2}
                  pageLanguageContents={pageLanguageContents}
                  paymentFor='subscription'
                />
              </div>
            </div>
          </div>
        </CreditCardSection>
      </StepFiveContainer>

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=""
        content={modalContent}
        link={modalLink}
        alertType={alertType}
        callBackAlert={() => setFieldValue("promoCodeChk", false)}
      />
    </>
  );
};
